import React from 'react';
import { X } from 'lucide-react';
import { widgetRegistry } from './widgetRegistry';

interface WidgetPickerProps {
  targetId: string;
  onSelect: (targetId: string, componentKey: string) => void;
  onClose: () => void;
}

const CATEGORY_LABELS: Record<string, string> = {
  kpi: 'KPI Cards',
  summary: 'Polymer Summaries',
  chart: 'Charts',
};

const WidgetPicker: React.FC<WidgetPickerProps> = ({ targetId, onSelect, onClose }) => {
  const categories = ['kpi', 'summary', 'chart'];

  return (
    <div className="fixed inset-0 bg-rs-black/70 z-50 flex items-center justify-center" onClick={onClose}>
      <div
        className="bg-rs-off-black border border-rs-jet-light rounded-xl shadow-2xl w-full max-w-lg mx-4 max-h-[80vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-center justify-between p-4 border-b border-rs-jet-light">
          <h2 className="text-rs-off-white font-medium">Choose Widget</h2>
          <button onClick={onClose} className="text-rs-off-white/50 hover:text-rs-off-white transition-colors">
            <X size={18} />
          </button>
        </div>

        <div className="p-4 flex flex-col gap-4">
          {categories.map((cat) => {
            const items = Object.entries(widgetRegistry).filter(([, e]) => e.category === cat);
            if (items.length === 0) return null;
            return (
              <div key={cat}>
                <p className="text-rs-off-white/50 text-sm uppercase tracking-wider mb-2">
                  {CATEGORY_LABELS[cat] || cat}
                </p>
                <div className="grid grid-cols-2 gap-2">
                  {items.map(([key, entry]) => (
                    <button
                      key={key}
                      onClick={() => { onSelect(targetId, key); onClose(); }}
                      className="text-left p-3 bg-rs-jet border border-rs-jet-light rounded-lg text-rs-off-white/70 hover:bg-rs-jet-light hover:text-rs-off-white transition-colors text-sm"
                    >
                      {entry.label}
                    </button>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default WidgetPicker;
